import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { PDF_WORKER_URL } from '@/config/pdfViewer';
import '@react-pdf-viewer/core/lib/styles/index.css';

/**
 * Renders a PDF's pages with no toolbar, so there is no download or print
 * button (OL-166, View Only links). The browser's own PDF viewer always has
 * both. The bytes come from `load` because B2 sends no CORS headers, so the
 * viewer can't read a presigned link.
 *
 * @param load  async () => Blob of the PDF
 */
const PdfViewer = ({ load }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;
    setUrl(null);
    setFailed(false);

    load()
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [load]);

  if (failed) {
    return <p className="py-20 text-sm text-gray-600">This document could not be opened. Please try again.</p>;
  }

  if (!url) {
    return <p className="py-20 text-sm text-gray-500">Opening…</p>;
  }

  return (
    <div className="w-full h-full" onContextMenu={(event) => event.preventDefault()}>
      <Worker workerUrl={PDF_WORKER_URL}>
        <Viewer fileUrl={url} />
      </Worker>
    </div>
  );
};

PdfViewer.propTypes = {
  load: PropTypes.func.isRequired,
};

export { PdfViewer };
